<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">Performance Management Review</span> -->
          <v-spacer></v-spacer>
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px"
                  >*Select the options to filter the results</span
                >
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2>
                <v-select
                  clearable
                  v-model="financialYear"
                  :items="financialYears"
                  label="Financial Year"
                  required
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
                <v-text-field
                  v-model="keyword"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Search Employee"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-flex align-self-center xs12 v-if="employeeList && employeeList.length > 0" px-4 pt-3>
          <v-simple-table class="align-center">
            <template v-slot:default>
              <thead style="background-color: #005f32">
                <tr>
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    No.
                  </th>
                  
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    Name
                  </th>
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    Designation
                  </th>
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    Grade
                  </th>
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    Rating
                  </th>
                  <th style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left">Financial Year</th>
                  <th
                    style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                    "
                    class="text-left"
                  >
                    Delete
                  </th>
                  <!-- <th class="text-left">View</th> -->
                </tr>
              </thead>
              <tbody class="align-center">
                <tr v-for="(item, i) in employeeList" :key="i">
                  <td class="text-left">
                    {{ i + 1 }}
                    <!-- <span v-if="page == 1">
                              {{ i + 1 }}
                            </span>
                            <span v-else>
                              {{ i + 1 + 20 * (page - 1) }}
                            </span> -->
                  </td>
                  
                  <td class="text-left">
                    <span
                      v-if="item.employeeId"
                      style="font-family: kumbhMedium"
                    >
                      {{ item.employeeId.name }}
                    </span>
                  </td>
                  <td class="text-left">
                    <span style="font-family: kumbhMedium">
                      {{ item.employeeId.positionid[0].name }}
                    </span>
                  </td>
                  <td class="text-left">
                    <span style="font-family: kumbhMedium">
                      {{ item.employeeId.grade }}
                    </span>
                  </td>
                  <td class="text-left">
                    <span style="font-family: kumbhMedium">
                      {{ item.rating }}
                    </span>
                  </td>
                  <td class="text-left">
                                        {{ item.fyear }}
                                      </td>
                  <td class="text-left">
                    <v-icon
                      small
                      @click="
                        (deleteDialog = true), (curitem = item._id)
                      "
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
        <v-flex v-else align-self-center xs12 pa-16 text-center>
          <span class="kumbhRegular">No data found</span>
        </v-flex>
      </v-flex>

      <v-dialog persistent v-model="deleteDialog" max-width="600px">
        <v-card>
          <v-card-title>Are you sure you want to delete this data?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      appLoading: false,
      employeeList: [],
      deleteDialog: false,
      curitem: null,
      msg: "",
      keyword: "",
      financialYear: "",
      financialYears: [],
      ServerError: false,
    };
  },
  mounted() {
    this.generateFinancialYears();
    this.getData();
  },
  watch: {
    keyword() {
      this.getData();
    },
    financialYear() {
      this.getData();
    },
  },
  methods: {
    generateFinancialYears() {
      const startYear = 2000;
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();

      // If the current month is before April (0-based index), it's still the previous financial year
      const endYear = currentMonth < 3 ? currentYear : currentYear + 1;

      for (let year = startYear; year <= endYear; year++) {
        this.financialYears.push(`${year}-${year + 1}`);
      }

      // Set default financial year to the current financial year
      const defaultStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
      this.financialYear = `${defaultStartYear}-${defaultStartYear + 1}`;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/pmr/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          search: this.keyword,
          year: this.financialYear,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.employeeList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem() {
      var data = {};
      data["id"] = this.curitem;
      axios({
        url: "/pmr/remove",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.deleteDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>